// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3zTUd","avatar":"style_avatar__3ggyO"};